import {compose, prop, path} from "ramda";

import API from "../index";
import {Profile, Account, UserPremiumStatus} from "./entities";
import {STATUS_NOT_FOUND} from "../../constants/httpStatusCodes";

const getProfile = () =>
  API.Account.getProfile().then(prop("data")).then(Profile);
const getAccount = () =>
  API.Account.getAccount().then(prop("data")).then(Account);

const getUserPremiumStatus = externalAccountId =>
  API.Subscription.getBenefits({externalAccountId})
    .then(compose(UserPremiumStatus, path(["data", "items"])))
    .catch(err => {
      if (err.status === STATUS_NOT_FOUND) {
        return UserPremiumStatus([]);
      }

      return {};
    });

const createEmailVerificationLink = () =>
  API.Account.createEmailVerificationLink().then(() => undefined);

export {
  getProfile,
  getAccount,
  getUserPremiumStatus,
  createEmailVerificationLink,
};
